import React, { useRef } from 'react';
import Toggle from '../Transition/Toggle';
import { timingMap } from '../Transition/constants';
import { st, classes } from './Collapse.st.css';
import { CollapseProps } from './Collapse.types';

/** Use `<Collapse/>` for hideable content.
 *
 * For example, create an accordion within `<Card/>` to collapse its `<Card.Content/>`
 * or to wrap <TopBanner/>.
 */
const Collapse = ({
  children,
  open = true,
  position = 'static',
  dataHook,
  mountOnEnter = true,
  unmountOnExit = true,
  onExpandAnimationEnd,
  onCollapseAnimationEnd,
}: CollapseProps) => {
  const wrapperRef = useRef(null);
  return (
    <div
      data-hook={dataHook}
      data-open={open}
      ref={wrapperRef}
      className={st(classes.root, { position })}
    >
      <Toggle
        timeout={timingMap['medium01']}
        show={open}
        unmountOnExit={unmountOnExit}
        mountOnEnter={mountOnEnter}
        onStart={onExpandAnimationEnd}
        onEnd={onCollapseAnimationEnd}
      >
        {children}
      </Toggle>
    </div>
  );
};

Collapse.displayName = 'Collapse';

export default Collapse;
